import { Button, LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { ModalFormField } from "components/Forms/FormRenderers/ModalFormRenderer";
import { PdfUpload, useSizePdfInModal } from "components/Forms/PdfUpload";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";
import { useMemo } from "react";
import routeService from "services/RouteService";
import { DocumentUploadModalController } from "./DocumentUploadModalController";
import { Account } from "@mixitone/models";

interface Props {
  clubId: string;
  documentName: string;
}

const DocumentUploadModal: React.FC<Props> = ({ documentName, clubId }) => {
  const controller = DocumentUploadModalController.use();
  const { loading, latestDocument } = controller.state;
  const fields = useMemo(() => controller.fields(), [controller]);

  const { pageHeight, handleLoad, pdfRef, modalRef } = useSizePdfInModal();

  const handleUpload = (documentId: string) => {
    controller.actionUploadComplete(documentId);
  };

  if (!Account.current?.hasFeature("member_players")) {
    return (
      <AppModal title="Access Denied" ref={modalRef}>
        <div className="p-4 text-center text-gray-500">
          To access documents, please{" "}
          <a href="/settings/account/billing" className="text-blue-500 hover:underline">
            upgrade to a Pro account
          </a>
          .
        </div>
      </AppModal>
    );
  }
  if (loading) return <LoadingModal title={"Document"} />;

  return (
    <AppModal title={`${documentName} (Version ${latestDocument?.version || "N/A"})`} ref={modalRef}>
      <div className="mb-2 flex justify-end">
        <Button
          kind="link"
          onClick={() =>
            routeService.openModal("/settings/clubs/:clubId/documents/:documentName/acceptances", {
              params: { clubId, documentName },
            })
          }
        >
          Acceptance register
        </Button>
      </div>
      <ModalFormField field={fields.audience} record={latestDocument} />
      <ModalFormField field={fields.acceptance} record={latestDocument} />
      <PdfUpload
        clubId={clubId}
        fileStorage={latestDocument?.file_storage}
        clubDocumentId={latestDocument?.id}
        onChange={handleUpload}
        onLoad={handleLoad}
        value={latestDocument?.document_id}
        ref={pdfRef}
        pageHeight={pageHeight}
      />
    </AppModal>
  );
};

export default injectModal(DocumentUploadModalController.scope(ApplicationView(DocumentUploadModal)));
